// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__ylGUi","rootCenter":"LoadMoreObserver_rootCenter__2wgmT","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__1K0-g"};